const loanFiai: string[] = [
  '001',
  '002',
  '003',
  '004',
  '005',
  '006',
  '007',
  '008',
  '009',
  '010',
  '011',
  '012',
  '013',
  '014',
  '015',
  '016',
  '024',
  '025',
  '028',
  '031',
  '035',
  '037',
  '038',
  '039',
  '040',
  '041',
  '042',
  '043',
]

const liabilityFiai: string[] = [
  '001',
  '013',
  '017',
  '018',
  '027',
  '033',
  '039',
  '040',
]

const trancheParentCalculatedFiai: string[] = ['001']
const trancheParentManualFiai: string[] = ['022', '023']

export {
  loanFiai,
  liabilityFiai,
  trancheParentCalculatedFiai,
  trancheParentManualFiai,
}
